import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Box } from '@material-ui/core';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function getWeeksAgo(dateString) {
  if (!dateString) return null;
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  return diffMs / (1000 * 60 * 60 * 24 * 7);
}

function getAverageAgeByBanner(data) {
  // Map: banner_name -> [weeksAgo, ...]
  const bannerMap = {};
  data.forEach(row => {
    const banner = row.banner_name;
    const date = row.last_collected_date;
    const weeksAgo = getWeeksAgo(date);
    if (!bannerMap[banner]) {
      bannerMap[banner] = [];
    }
    bannerMap[banner].push(weeksAgo);
  });
  // Convert to array: [{ banner, avgWeeksAgo }]
  return Object.entries(bannerMap).map(([banner, arr]) => ({
    banner,
    avgWeeksAgo: arr.reduce((a, b) => a + b, 0) / arr.length,
  })).sort((a, b) => b.avgWeeksAgo - a.avgWeeksAgo);
}

export default function CompanyAverageDataAgeChart({ outOfDateProducts }) {
  const dataByBanner = getAverageAgeByBanner(outOfDateProducts || []);
  const labels = dataByBanner.map(item => item.banner);
  const avgWeeksAgo = dataByBanner.map(item => Number(item.avgWeeksAgo.toFixed(2)));

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Average age (weeks)',
        data: avgWeeksAgo,
        backgroundColor: '#2196F3',
        borderRadius: 4,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Average Data Age by Company Website',
        font: { size: 22 },
      },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Company Website',
          font: { size: 16 },
        },
        ticks: {
          callback: function(value, index) {
            return this.getLabelForValue(value);
          },
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Average age (weeks)',
          font: { size: 16 },
        },
        grid: { color: '#eee' },
      },
    },
  };

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', minHeight: '400px', maxHeight: '600px' }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
} 